import React, {useContext} from 'react';
import {LanguageContext, LanguageDispatch} from '../context/LanguageContext';

const LANGUAGES = [
    {code: 'pl', label: 'PL'},
    {code: 'it', label: 'IT'},
    {code: 'en', label: 'EN'},
];

const LanguageSwitcher = () => {
    const {language, t} = useContext(LanguageContext);
    const dispatch = useContext(LanguageDispatch);

    const handleChange = (code) => {
        const url = new URL(window.location.href);
        if (code === 'pl') {
            url.searchParams.delete('lang');
        } else {
            url.searchParams.set('lang', code.toUpperCase());
        }
        window.location.href = url.toString();
    };

    return (
        <div className="language-switcher" role="none">
            {LANGUAGES.map((lang, idx) => (
                <React.Fragment key={lang.code}>
                    <button
                        className={`language-switcher__btn${language === lang.code ? ' language-switcher__btn--active' : ''}`}
                        onClick={() => handleChange(lang.code)}
                        role="menuitem"
                        aria-current={language === lang.code ? 'true' : undefined}
                        type="button"
                    >
                        {lang.label}
                    </button>
                    {idx < LANGUAGES.length - 1 && (
                        <span className="language-switcher__separator" aria-hidden="true">|</span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default LanguageSwitcher;
